import {twMerge} from '@sdox/utils'

import type {ComponentProps} from 'react'

export interface ListProps extends ComponentProps<'ul'> {
  lined?: boolean
}

export const List = ({children, lined, className, ...restProps}: ListProps) => (
  <ul
    className={twMerge('flex flex-col divide-y divide-gray-200', className)}
    {...restProps}
  >
    {children}
  </ul>
)
